import React from "react";
import PurchaseWindowFail from "./PurchaseWindowFail";
import PagePopopCloseButton from "components/page-components/PagePopopCloseButton";

const PurchaseWindowPaymentFailed = ({ close }) => {
  return (
    <div className="modal-window__wrapper" onClick={(e) => e.stopPropagation()}>
      <PagePopopCloseButton close={close} />
      <PurchaseWindowFail close={close} />
    </div>
  );
};

export default PurchaseWindowPaymentFailed;
